import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import { useState } from "react";
import Home from "./pages/Home";
import Gallery from "./pages/Gallery";
import Upload from "./pages/Upload";
import "./App.css";
import logo from "./photocall_logo.png";

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <Router>
      <div className="app-container">
        <button className="menu-toggle" onClick={toggleMenu}>
          <span className="menu-icon"></span>
          <span className="menu-icon"></span>
          <span className="menu-icon"></span>
        </button>
        <nav className="nav-bar">
          <div className="nav-content">
            <div className="logo">
              <Link className="logo-link" to="/">
                <img className="logo-image" src={logo} alt="Suko Photocall" />
                <h4>
                  Photocall <span className="logo-span">by Suko</span>
                </h4>
              </Link>
            </div>
          </div>
        </nav>

        <div
          className={`modal-menu ${isMenuOpen ? "open" : ""}`}
          onClick={toggleMenu}
        >
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            {/* <div className="modal-header">
              <h2>Menú</h2>
              <button className="close-button" onClick={toggleMenu}>×</button>
            </div> */}
            <div className="modal-links">
              <Link to="/" onClick={toggleMenu}>
                Inicio
              </Link>
              <Link to="/get-code" onClick={toggleMenu}>
                Pide tu código
              </Link>
              <Link to="/prices" onClick={toggleMenu}>
                Precios
              </Link>
            </div>
            <div className="close-button-container">
              <button className="close-button" onClick={toggleMenu}>
                ×
              </button>
            </div>
          </div>
        </div>

        <div className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/get-code" element={<Home />} />
            <Route path="/prices" element={<Home />} />
            <Route path="/gallery/:id" element={<Gallery />} />
            <Route path="/gallery/:id/upload" element={<Upload />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
